module.exports = window["SSCUI"];